import {
  Pause,
  PlayArrow,
  Cancel,
  SwapHoriz,
  LocalOffer,
  Payment,
  Receipt,
} from '@mui/icons-material'

export enum BillingEventType {
  PAUSE = 'pause',
  RESUME = 'resume',
  CANCELLATION = 'cancellation',
  TIER_CHANGE = 'tier_change',
  TERM_CHANGE = 'term_change',
  PAYMENT_TYPE_CHANGE = 'payment_type_change',
  DISCOUNT_APPLIED = 'discount_applied',
  DISCOUNT_REMOVED = 'discount_removed',
  CHARGE = 'charge',
  PAYMENT = 'payment',
  TRANSACTION = 'transaction',
}

export const BILLING_EVENT_ICONS = {
  [BillingEventType.PAUSE]: Pause,
  [BillingEventType.RESUME]: PlayArrow,
  [BillingEventType.CANCELLATION]: Cancel,
  [BillingEventType.TIER_CHANGE]: SwapHoriz,
  [BillingEventType.TERM_CHANGE]: SwapHoriz,
  [BillingEventType.PAYMENT_TYPE_CHANGE]: SwapHoriz,
  [BillingEventType.DISCOUNT_APPLIED]: LocalOffer,
  [BillingEventType.DISCOUNT_REMOVED]: LocalOffer,
  [BillingEventType.CHARGE]: Receipt,
  [BillingEventType.PAYMENT]: Payment,
  [BillingEventType.TRANSACTION]: Receipt,
} as const

export const BILLING_EVENT_COLORS = {
  [BillingEventType.PAUSE]: '#ff9800', // Orange
  [BillingEventType.RESUME]: '#4caf50', // Green
  [BillingEventType.CANCELLATION]: '#f44336', // Red
  [BillingEventType.TIER_CHANGE]: '#2196f3', // Blue
  [BillingEventType.TERM_CHANGE]: '#2196f3', // Blue
  [BillingEventType.PAYMENT_TYPE_CHANGE]: '#2196f3', // Blue
  [BillingEventType.DISCOUNT_APPLIED]: '#9c27b0', // Purple
  [BillingEventType.DISCOUNT_REMOVED]: '#757575', // Grey
  [BillingEventType.CHARGE]: '#f44336', // Red
  [BillingEventType.PAYMENT]: '#4caf50', // Green
  [BillingEventType.TRANSACTION]: '#607d8b', // Blue Grey
} as const

export const BILLING_EVENT_LABELS = {
  [BillingEventType.PAUSE]: 'Paused',
  [BillingEventType.RESUME]: 'Resumed',
  [BillingEventType.CANCELLATION]: 'Cancelled',
  [BillingEventType.TIER_CHANGE]: 'Tier Changed',
  [BillingEventType.TERM_CHANGE]: 'Billing Frequency Changed',
  [BillingEventType.PAYMENT_TYPE_CHANGE]: 'Payment Type Changed',
  [BillingEventType.DISCOUNT_APPLIED]: 'Discount Applied',
  [BillingEventType.DISCOUNT_REMOVED]: 'Discount Removed',
  [BillingEventType.CHARGE]: 'Charge',
  [BillingEventType.PAYMENT]: 'Payment',
  [BillingEventType.TRANSACTION]: 'Transaction',
} as const

export interface BillingEvent {
  event_id: string
  event_type: BillingEventType | string
  event_date: string
  actor: string
  actor_type: 'user' | 'system'
  description: string
  details?: Record<string, any>
  financial_impact?: number | null
}

export interface BillingHistoryResponse {
  data: BillingEvent[]
  total: number
}
